// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/platform/platform-short.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : apps/web/src/lib/platform.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo tendly-app
//     node fleet/fleet.ts check --repo tendly-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
/**
 * Runtime platform detection.
 *
 * True when the page is being served inside a Tauri WebView. Mirrors what
 * `@tauri-apps/api/core`'s `isTauri()` checks — we read the global directly
 * to avoid having to load the Tauri JS module just for a feature flag.
 */
export function isTauriRuntime(): boolean {
  return "__TAURI_INTERNALS__" in globalThis;
}
